import { checkVAT, countries } from "jsvat";

const HAS_COUNTRY_PREFIX = /^[A-Za-z]{2}/;

export function isValidNip(taxNo: string): boolean {
  const normalized = HAS_COUNTRY_PREFIX.test(taxNo) ? taxNo : `PL${taxNo}`;
  return checkVAT(normalized, countries).isValid;
}
